import angular from 'angular';

import CalendarDayEventModule from './calendar-day-event';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-day.component', [
        CalendarDayEventModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/component/index.js